export default [
  {
    path: '/vistoria/:vistoriaId/ambiente-new',
    name: 'AmbienteCreate',
    component: () => import('./AmbienteForm'),
    meta: {
      routerBack: '/vistoria/:vistoriaId/imovel-ambiente',
      domain: 'Ambiente',
      sidebar: false,
      title: 'Novo ambiente',
      icon: 'keyboard_backspace',
    },
  },
  {
    name: 'Editar ambiente',
    path: '/vistoria/:vistoriaId/ambiente-edit/:id',
    meta: {
      sidebar: false,
      routerBack: '/vistoria/:vistoriaId/imovel-ambiente',
      domain: 'Ambiente',
      title: 'Editar ambiente',
      icon: 'keyboard_backspace',
    },
  },
];



// WEBPACK FOOTER //
// ./src/app/Imovel/Vistoria/Ambiente/AmbienteForm/ImovelAmbienteFormRouter.js